import React from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationButton from './NotificationButton';

function NavigationBar({ signOut, user }) {
  const navigate = useNavigate();
  return (
    <nav className="navigation">
      <div className="navigation__container">
        <span>Hey {user?.username || 'there'}, welcome!</span>
        <div className="navigation__actions">
          <button
            onClick={() => navigate(`/events`)}
            className="button button--primary">
            Events
          </button>
          <button
            onClick={() => navigate(`/profile`)}
            className="button button--primary">
            Profile
          </button>
          <button
            onClick={() => navigate(`/events/create`)}
            className="button button--primary">
            Create Event
          </button>
          {signOut && (
            <button 
              onClick={signOut}
              className="button button--danger">
              Sign out
            </button>
          )}
          <div className="notification__container">
            <NotificationButton />
          </div>
        </div>      
      </div>
    </nav>
  );
}

export default NavigationBar;